import type { IMultiselectItem } from 'components/Multiselect/Multiselect';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { Maybe, ProjectMethodologyEnum } from 'gql/graphql';
import { SortEnumType, CatalogOtherCostVariableTypeEnum } from 'gql/graphql';

import { useEffect, useMemo } from 'react';

import { catalogOtherCostVariableDataSourcesGql } from '../catalogVariablesQueries';

export const useDataSources = (
    type: string | undefined,
    entities: Maybe<IMultiselectItem[] | undefined>,
    methodology: ProjectMethodologyEnum,
) => {
    const variables = useMemo(
        () => ({
            entityUniqueIds: entities?.map(({ id }) => String(id)) ?? [],
            methodology,
            order: [
                {
                    name: SortEnumType.Asc,
                },
            ],
        }),
        [entities, methodology],
    );

    const [dataSourcesReset] = useResetStoreData({
        requestId: 'catalogOtherCostVariableDataSources',
    });

    useEffect(
        () => () => {
            dataSourcesReset(undefined);
        },
        [dataSourcesReset],
    );

    const [dataSourcesData, dataSourcesStatus] = useRequest({
        requestId: 'catalogOtherCostVariableDataSources',
        query: catalogOtherCostVariableDataSourcesGql,
        variables,
        withEffect: !!entities && type === CatalogOtherCostVariableTypeEnum.Simple,
    });

    return useMemo(
        () => ({
            dataSourcesData: entities ? dataSourcesData?.catalogOtherCostVariableDataSources?.items ?? [] : [],
            dataSourcesStatus,
        }),
        [dataSourcesData?.catalogOtherCostVariableDataSources?.items, dataSourcesStatus, entities],
    );
};
